import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpResponse, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {Observable, Subscription} from 'rxjs';
import {Contract, IContract} from '../../shared/model/contract.model';
import {ContractService} from './contract.service';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ITransaction, Transaction} from '../../shared/model/transaction.model';
import {NgxSpinnerService} from 'ngx-spinner';
import {Customer, ICustomer} from '../../shared/model/customer.model';
import {Organization} from '../../shared/model/organization.model';
import * as moment from 'jalali-moment';
import {Employee, IEmployee} from '../../shared/model/employee.model';
import {EmployeeService} from '../../core/employee/employee.service';
import {CustomerService} from '../customer/customer.service';
import {IProject, Project} from "../../shared/model/project.model";
import {ISalesCycle, SalesCycle} from "../../shared/model/salesCycle.model";
import {AccountService} from "../../singelton/account.service";
import {TransactionService} from "../transaction/transaction.service";
import {TransactionUpdateComponent} from "../transaction/transaction-update.component";
import {CalendarService} from "../calendar/calendar.service";
import {INote} from "../../shared/model/note.model";
import {TransactionUpdatePeriodicComponent} from "../transaction/transaction-update-periodic.component";
import {FileObjectListProjectComponent} from "../file/file-object-list-project.component";
import {IFileObject} from "../../shared/model/file-object.model";
import {FileObjectService} from "../file/file-object.service";
import {FileObjectUpdateComponent} from "../file/file-object-update.component";
import {CustomerFile} from "../../shared/model/customer-file.model";
import {FileDeleteDialogComponent} from "../file/file-delete-dialog.component";
import {ContractDeleteDialogComponent} from "./contract-delete-dialog.component";


@Component({
  selector: 'app-contract-update',
  templateUrl: './contract-update.component.html'
})
export class ContractUpdateComponent implements OnInit {
  contract: IContract = new Contract();
  isSaving: boolean;
  // business_tyep: any = BUSINESS_TYPE;
  width = '';
  @Input() contractEdit;
  @Input() transactionId;
  @Input() customerId;
  @Input() project;
  @Input() salesCycle;
  @Input() projects_list;
  @Input() salesCycles_list;
  @Input() action;

  employees: IEmployee[];
  projects: IProject[];
  salesCycles: ISalesCycle[];
  currentDate: INote;
  h_temp: any;

  startDateObject: any;
  endDateObject: any;
  currentAccount: any;
  contracts: IContract[];
  error: any;
  success: any;
  eventSubscriber: Subscription;
  routeData: any;
  links: any;
  totalItems: any;
  queryCount: any;
  itemsPerPage: any;
  page: any;
  predicate: any;
  previousPage: any;
  reverse: any;
  closeResult: string;
  showForm = false;
  customers: ICustomer[];
  fileObjects: IFileObject[];
  commentObject: IContract = new Contract();
  customer: ICustomer = new Customer();
  file: IFileObject = new CustomerFile();

  keyword = 'title';
  audience_keyword = 'audience';
  audience_default = '';

  selectEvent(item) {
    this.contract.customer = new Customer(item.id);
  }

  onChangeSearch(val: string) {
    this.search(this.page);
  }

  onFocused(e) {
  }


  constructor(protected contractService: ContractService, protected activatedRoute: ActivatedRoute, public activeModal: NgbActiveModal,
              protected employeeService: EmployeeService, protected customerService: CustomerService,
              private spinner: NgxSpinnerService,
              private modalService: NgbModal,
              public accountService: AccountService,
              protected transactionService: TransactionService,
              protected calendarService: CalendarService,
              protected router: Router,
              protected fileObjectService: FileObjectService) {
    this.itemsPerPage = 20;
    this.page = 1;
    this.predicate = 'id';
    this.reverse = 'asc';

  }

  ngOnInit() {
    this.isSaving = false;
    if (this.projects_list) {
      this.projects = this.projects_list;
    }
    if (this.salesCycles_list) {
      this.salesCycles = this.salesCycles_list;
    }
    if (this.project) {
      this.contract.project = this.project;
      this.contract.customer = this.project.customer;
    }
    if (this.salesCycle) {
      this.contract.salesCycle = this.salesCycle;
      this.contract.customer = this.salesCycle.customer;
    }
    // alert('customerId =='+this.customerId);
    if (this.action != 'add') {
      this.activatedRoute.params.subscribe((params) => {
        this.customerId = params['customerId'];
        this.contractEdit = params['contractEdit'];
      })
    }
    if (this.customerId) {
      this.showForm = true;

      this.contract.customer = new Customer(this.customerId);

    } else {

      this.search(1);
    }
    if (this.transactionId) {
      this.loadAll();
    }

    this.loadContract();
    this.loadAllEmployee();
    this.getCurrentDate();
  }

  calculateDate(start, end) {
    let month = 1;
    if (start && end) {
      const startDate = new Date(start + '');
      const endDate = new Date(end + '');
      let timeDiff = (endDate.getTime() - startDate.getTime());
      if (endDate.getTime < startDate.getTime) {
        timeDiff = -1 * timeDiff;
      }

      const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));


      // value = diffDays;
      const valueNumber = Number(diffDays + '') + 1;
      if (valueNumber >= 30) {
        month = Math.round(valueNumber / 30);
      }
      return month;
    } else {
      return '-';
    }
  }

  deleteFile(data: any) {
    const modalRef = this.modalService.open(FileDeleteDialogComponent, {windowClass: 'lg', backdrop: 'static'});
    modalRef.componentInstance.action = 'delete';
    modalRef.componentInstance.fileId = data;
    modalRef.componentInstance.fileEdit = data;

    modalRef.result.then(
      res => {
        this.loadAllFilesContract();
      },
      rejected => {
        this.loadAllFilesContract();
      }
    );
  }

  deleteContract(id) {
    const modalRef = this.modalService.open(ContractDeleteDialogComponent, {windowClass: 'lg', backdrop: 'static'});
    modalRef.componentInstance.contractEdit = id;
    modalRef.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.loadContract();
      }
    );
  }

  downloadFile(id) {

    this.fileObjectService.find(id).subscribe((res: HttpResponse<IFileObject>) => {
        this.file = res.body;
        const tabWindowId = window.open('about:blank', '_blank');
        tabWindowId.location.href = this.file.amazonLink;
      },
      (res: HttpErrorResponse) => console.log('______ error ______')
    );
  }

  styleObject(value, status, status_2): Object {
    // const today = new Date();
    const today = new Date(this.currentDate.description);

    if (value) {
      var h_value: any[] = value.split('T');
      value = h_value[0] + ' ' + this.h_temp;
    }

    const dateExpiration = new Date(value + '');
    let timeDiff = (dateExpiration.getTime() - today.getTime());
    if (dateExpiration.getTime < today.getTime) {
      timeDiff = -1 * timeDiff;
    }
    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    value = diffDays;
    const valueNumber = Number(value + '');

    if (status_2 && status_2 === 'Completed') {
      this.width = '100%';
      return {width: this.width, 'background-color': '#168016'};

    } else {

      if (valueNumber <= 0) {
        this.width = '100%';
        return {width: this.width, 'background-color': '#dc3545'};
      } else if (valueNumber < 7 && valueNumber > 0) {
        this.width = '80%';
        return {width: this.width, 'background-color': '#ffc107'};
      } else if (valueNumber < 60 && valueNumber > 0) {
        this.width = '75%';
        return {width: this.width, 'background-color': '#17a2b8'};
      } else if (valueNumber < 90 && valueNumber > 0) {
        this.width = '75%';
        return {width: this.width, 'background-color': '#17a2b8'};
      } else if (isNaN(valueNumber)) {
        if (status && status === 'Optional') {
          this.width = '1%';
          return {'color': '#dc3545', paddingLeft: '1px', 'background-color': '#eaeaea'};
        } else {
          this.width = '1%';
          return {'color': '#dc3545', paddingLeft: '1px', 'background-color': '#eaeaea'};
        }
      } else {
        this.width = '75%';
        return {width: this.width, 'background-color': '#17a2b8'};
      }
    }
  }

  percentCellRenderer(value, status, status_2) {
    let temp = '';
    // const today = new Date();
    const today = new Date(this.currentDate.description);

    if (value) {
      var h_value: any[] = value.split('T');
      value = h_value[0] + ' ' + this.h_temp;
    }
    const dateExpiration = new Date(value + '');
    let timeDiff = (dateExpiration.getTime() - today.getTime());
    if (dateExpiration.getTime < today.getTime) {
      timeDiff = -1 * timeDiff;
    }

    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));


    value = diffDays;
    const valueNumber = Number(value + '');
    let valueStr = '';
    const eDivPercentBar = document.createElement('div');
    eDivPercentBar.className = '';
    const eValue = document.createElement('div');
    valueStr = 'Expired';

    eValue.className = 'progress-bar progress-bar-striped bg-primary';
// alert('valueNumber='+valueNumber);
    if (status_2 && status_2 === 'Completed') {
      valueStr = 'تکمیل شده';
      eValue.style.width = '100%';
      eValue.style.paddingLeft = '1px';
      eValue.style.color = 'green';

    } else {
      if (valueNumber < 0) {
        eValue.style.width = '100%';
        eValue.className = 'progress-bar progress-bar-striped bg-danger';
        valueStr = '' + Math.abs(value) + ' روز گذشته';
      } else if (valueNumber === 0) {
        eValue.style.width = '100%';
        eValue.className = 'progress-bar progress-bar-striped bg-danger';
        // valueStr = '' + Math.abs(value) + ' روز مانده';
        valueStr = 'امروز';
      } else if (valueNumber < 30 && valueNumber > 0) {
        eValue.style.width = '80%';
        valueStr = value + ' روز دیگر';
        eValue.className = 'progress-bar progress-bar-striped bg-warning';
      } else if (valueNumber < 60 && valueNumber > 0) {
        eValue.style.width = '60%';
        valueStr = value + ' روز دیگر';
        eValue.className = 'progress-bar progress-bar-striped bg-info';
      } else if (valueNumber < 90 && valueNumber > 0) {
        valueStr = value + ' روز دیگر';
        eValue.style.width = '40%';
        eValue.className = 'progress-bar progress-bar-striped bg-succsess';
      } else if (isNaN(valueNumber)) {
        if (status && status === 'Optional') {
          valueStr = 'بدون مهلت';
          eValue.style.width = '1%';
          eValue.style.paddingLeft = '1px';
          eValue.style.color = 'red';
        } else {
          // valueStr = 'Not Uploaded';
          valueStr = 'بدون مهلت';

          eValue.style.width = '1%';
          eValue.style.paddingLeft = '1px';
          eValue.style.color = 'red';
        }
        eValue.className = 'progress-bar progress-bar-striped bg-primary';
      } else {
        eValue.style.width = '45%';
        valueStr = value + ' روز';
        eValue.className = 'progress-bar progress-bar-striped bg-primary';
      }
    }
    const eOuterDiv = document.createElement('div');
    eOuterDiv.className = 'progress mb-2';
    eOuterDiv.style.marginTop = '12px';
    eOuterDiv.appendChild(eValue);
    const re = /&lt;/gi;
    const re2 = /&gt;/gi;
    const str = eOuterDiv.outerHTML;
    const newstr = str.replace(re, '<').replace(re2, '>');
    const newstr2 = str.replace(re, '>');
    return valueStr;
  }


  editTransactionForContract(data: any, type, contract) {

    const modalRef = this.modalService.open(TransactionUpdateComponent, {windowClass: 'sm', backdrop: 'static'});
    modalRef.componentInstance.action = 'edit';
    modalRef.componentInstance.type = type;
    modalRef.componentInstance.customer_contract_param = contract;
    modalRef.componentInstance.part = 'contract';

    modalRef.componentInstance.transactionEdit = data;
    // modalRef.componentInstance.projects_list = this.projects;
    modalRef.componentInstance.employees_list = this.employees;
    // modalRef.componentInstance.phones_list = this.phones;
    // modalRef.componentInstance.contracts_list = this.contracts;

    modalRef.componentInstance.customerId = contract.customer.id;

    modalRef.result.then(
      res => {
        // this.loadTransaction();
        this.loadContract();
        // this.loadAllFilesContract();
      },
      rejected => {
        // this.loadTransaction();
        this.loadContract();
        // this.loadAllFiles();

      }
    );
  }

  completedTransactionForContract(data: any, type, contract) {
    const modalRef = this.modalService.open(TransactionUpdateComponent, {windowClass: 'sm', backdrop: 'static'});
    modalRef.componentInstance.action = 'completed';
    modalRef.componentInstance.type = type;
    modalRef.componentInstance.transactionEdit = data;
    modalRef.componentInstance.customer_contract_param = contract;
    modalRef.componentInstance.part = 'contract';

    // modalRef.componentInstance.projects_list = this.projects;
    modalRef.componentInstance.employees_list = this.employees;
    // modalRef.componentInstance.phones_list = this.phones;
    // modalRef.componentInstance.contracts_list = contracts;
    modalRef.componentInstance.customerId = contract.customer.id;


    modalRef.result.then(
      res => {
        // this.loadTransaction();
        this.loadContract();
        // this.loadAllFiles();
      },
      rejected => {
        // this.loadTransaction();
        this.loadContract();
        // this.loadAllFiles();
      }
    );
  }

  editContract(contract) {
    // editContract(id) {
    // this.router.navigate(['/page/contract/' + contract.id + '/' + customer.id]);

    const modalRef = this.modalService.open(ContractUpdateComponent, {windowClass: 'lg', backdrop: 'static'});
    modalRef.componentInstance.contractEdit = contract.id;
    modalRef.componentInstance.customerId = contract.customer.id;
    // modalRef.componentInstance.projects_list = this.projects;
    // modalRef.componentInstance.salesCycles_list = this.salesCycles;
    modalRef.componentInstance.action = 'add';

    modalRef.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;

      }, (reason) => {
        this.loadContract();
      }
    );
  }

  loadContract() {
    if (this.contractEdit) {

      // this.spinner.show();
      this.contractService.find(this.contractEdit).subscribe(
        (res: HttpResponse<IContract>) => {
          this.contract = res.body;
          if (this.action !== 'add') {
            this.loadAllFilesContract();
            const contractId = this.contract.id;
            this.transactionService.findAllTransactionWithContractId({
              page: this.page - 1,
              size: this.itemsPerPage,
              sort: this.sort2(),
              contractId

            }).subscribe(
              (res: HttpResponse<ITransaction[]>) => {
                this.contract.transactions = res.body;
              },
              (res: HttpErrorResponse) => this.onError(res.message)
            );
          }
          if (this.contract.cost) {
            this.contract.cost = this.numberWithCommas(this.contract.cost);
          }
          if (this.contract.start) {
            const jalaliDate5 = moment(this.contract.start).locale('fa').format('jYYYY/jM/jD HH:mm:ss'); // 1367/11/4
            this.startDateObject = moment(jalaliDate5, 'jYYYY,jMM,jDD  HH:mm:ss');
          }
          if (this.contract.end) {
            const jalaliDate_end = moment(this.contract.end).locale('fa').format('jYYYY/jM/jD HH:mm:ss'); // 1367/11/4
            this.endDateObject = moment(jalaliDate_end, 'jYYYY,jMM,jDD  HH:mm:ss');
          }
          if (this.contract && this.contract.project && this.contract.project.id) {
            this.contract.project_str = this.contract.project.id;
          }
          if (this.contract && this.contract.salesCycle && this.contract.salesCycle.id) {
            this.contract.salesCycle_str = this.contract.salesCycle.id;
          }
        },
        (res: HttpErrorResponse) => this.onError(res.message)
      );
    }

  }

  getCurrentDate() {
    let temp = '';


    this.calendarService
      .getCurrentDate()
      .subscribe(
        (res: HttpResponse<any>) => {
          this.currentDate = res.body;
          this.h_temp = this.currentDate.description.split(' ')[1];

        },
        (res: HttpErrorResponse) => this.onError(res.message)
      );

  }


  sort2() {
    const result = [this.predicate + ',' + (this.reverse ? 'desc' : 'desc')];
    if (this.predicate !== 'id') {
      result.push('id');
    }
    return result;
  }

  loadAll() {
    if (this.transactionId) {
      this.spinner.show();
    }
    this.contractService.query(
      this.transactionId).subscribe(
      (res: HttpResponse<IContract[]>) => {
        this.contracts = res.body;
        this.spinner.hide();

      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }

  parsePriority(value) {
    let return_value = '';
    if (value === 'low') {
      return_value = 'کم';
    } else if (value === 'medium') {
      return_value = 'متوسط';
    } else if (value === 'top') {
      return_value = 'بالا';
    }
    return return_value;
  }

  parseDateJalali(value) {
    let jalaliDate5 = '-';
    if (value) {
      jalaliDate5 = moment(new Date(value)).locale('fa').format('jYYYY/jM/jD');
    }
    return jalaliDate5;
  }

  parseDate(value) {
    let jalaliDate5 = '-';
    if (value) {
      jalaliDate5 = moment(value).locale('fa').format('jYYYY/jM/jD');
    }
    return jalaliDate5;
  }

  addTransactionPeriodic(val, contract) {
    const modalRef = this.modalService.open(TransactionUpdatePeriodicComponent, {
      windowClass: 'sm',
      backdrop: 'static'
    });
    modalRef.componentInstance.action = 'add';
    modalRef.componentInstance.type = val;
    // modalRef.componentInstance.projects_list = this.projects;
    // modalRef.componentInstance.salesCycles_list = this.salesCycles;
    // modalRef.componentInstance.employees_list = this.employees;
    // modalRef.componentInstance.phones_list = this.phones;
    // modalRef.componentInstance.contracts_list = this.contracts;
    modalRef.componentInstance.customerId = this.contract.customer.id;
    modalRef.componentInstance.part = 'other';
    modalRef.componentInstance.customer_contract_param = contract;
    modalRef.componentInstance.customer_contract_param_id = contract.id;


    modalRef.result.then(
      res => {
        // this.loadTransactionWithoutPProject();
        // this.loadAllFiles();
        // this.loadAllSalesCycle();
        // this.loadAllProject();
        this.loadContract();

      },
      rejected => {
        // this.loadTransactionWithoutPProject();
        // this.loadAllFiles();
        // this.loadAllSalesCycle();
        // this.loadAllProject();
        this.loadContract();


      }
    );
  }

  addTransactionForContract(val, contract) {
    const modalRef = this.modalService.open(TransactionUpdateComponent, {windowClass: 'sm', backdrop: 'static'});
    modalRef.componentInstance.action = 'add';
    modalRef.componentInstance.customer_contract_param = contract;
    modalRef.componentInstance.type = val;
    modalRef.componentInstance.part = 'contract';


    // modalRef.componentInstance.projects_list = this.projects;
    // modalRef.componentInstance.employees_list = this.employees;
    // modalRef.componentInstance.phones_list = this.contract.customer.phones;
    // modalRef.componentInstance.contracts_list = this.contracts;
    modalRef.componentInstance.customerId = this.contract.customer.id;

    modalRef.result.then(
      res => {
        this.loadContract();
        // this.loadTransaction();
        // this.loadAllFiles();

      },
      rejected => {
        this.loadContract();
        // this.loadTransaction();
        // this.loadAllFiles();


      }
    );
  }

  checkEditTime(value) {
    let temp = false;
    const today = new Date(this.currentDate.description);

    if (value) {
      var h_value: any[] = value.split('T');
      value = h_value[0] + ' ' + this.h_temp;
    }
    const dateExpiration = new Date(value + '');
    let timeDiff = (dateExpiration.getTime() - today.getTime());
    if (dateExpiration.getTime < today.getTime) {
      timeDiff = -1 * timeDiff;
    }

    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

    value = diffDays;
    const valueNumber = Number(value + '');
    if (valueNumber < -1) {
      temp = true;
    } else if (valueNumber >= -1) {
      temp = false;
    }

    return temp;
  }

  search(page) {
    if (page) {
      this.page = page;
    } else {
      this.page = 1;
    }

    this.spinner.show();

    const title = (this.customer.title ? this.customer.title : '');

    this.customerService
      .searchAnutocomplete({
        page: this.page - 1,
        size: this.itemsPerPage,
        // sort: this.sortCustomer(),
        title

      })
      .subscribe(
        (res: HttpResponse<ICustomer[]>) => this.paginateCustomers(res.body, res.headers),
        (res: HttpErrorResponse) => this.onError(res.message)
      );

  }


  protected paginateCustomers(data: ICustomer[], headers: HttpHeaders) {
    this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
    this.queryCount = this.totalItems;
    this.customers = data;
    this.spinner.hide();
  }


  sortCustomer() {
    const result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
    if (this.predicate !== 'id') {
      result.push('id');
    }
    return result;
  }

  sort(predicate, reverse) {
    let result = ['id, desc'];
    if (predicate) {
      result = [predicate + ',' + reverse];
      return result;
    }
  }

  openFileContract(contract) {

    const modalRef = this.modalService.open(FileObjectUpdateComponent, {size: 'sm', backdrop: 'static'});
    modalRef.componentInstance.action = 'add';
    modalRef.componentInstance.customerId = this.contract.customer.id;
    modalRef.componentInstance.contractId = contract;

    modalRef.result.then(res => {
      console.log(res + ' the result of popup');
      this.loadAllFilesContract();
    }, rejected => {
      console.log(' rejected: ' + rejected.toString());
      this.loadAllFilesContract();
    });

  }


  loadAllFilesContract() {
    if (this.contractEdit) {
      this.fileObjectService.findWithContractId({
        page: 0,
        size: 20
      }, this.contractEdit).subscribe(
        (res: HttpResponse<IFileObject[]>) => this.onSuccessFiles(res.body, res.headers),
        (res2: HttpResponse<any>) => this.onError(res2.body)
      );
    }
  }

  private onSuccessFiles(data, headers) {
    this.fileObjects = data;
    this.totalItems = headers.get('X-Total-Count');
    this.spinner.hide();

  }

  protected paginateContracts(data: IContract[], headers: HttpHeaders) {
    // this.links = this.parseLinks.parse(headers.get('link'));
    this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
    this.queryCount = this.totalItems;
    this.contracts = data;
  }

  protected onError(errorMessage: string) {
  }

  previousState() {
    window.history.back();
  }


  loadAllEmployee() {
    this.employeeService.query().subscribe(
      (res: HttpResponse<IEmployee[]>) => {
        this.employees = res.body;
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }

  save() {
    this.isSaving = true;
    if (this.contract.cost) {
      this.contract.cost = this.disNumberWithCommas(this.contract.cost);
    }
    const span_startDate = document.getElementById('span_startDate');
    if (span_startDate) {
      this.contract.start = (<HTMLInputElement>span_startDate).innerHTML;
    }
    const span_endDate = document.getElementById('span_endDate');
    if (span_endDate) {
      this.contract.end = (<HTMLInputElement>span_endDate).innerHTML;
    }

    if (this.customerId) {
      this.contract.customer = new Customer(this.customerId);

    } else {

      this.search(1);
    }
    if (this.contract.employee_str) {
      this.contract.employee = new Employee(this.contract.employee_str);
    }
    if (this.contract.project_str) {
      this.contract.project = new Project(this.contract.project_str);
    }
    if (this.contract.salesCycle_str) {
      this.contract.salesCycle = new SalesCycle(this.contract.salesCycle_str);
    }

    if (this.contract.id !== undefined && this.contract.id != null) {
      this.subscribeToSaveResponse(this.contractService.update(this.contract));
    } else {
      this.subscribeToSaveResponse(this.contractService.create(this.contract));
    }
  }

  protected subscribeToSaveResponse(result: Observable<HttpResponse<IContract>>) {
    result.subscribe((res: HttpResponse<IContract>) => this.onSaveSuccess(res), (res: HttpErrorResponse) => this.onSaveError());
  }

  protected onSaveSuccess(res) {
    this.isSaving = false;
    this.contract = res.body;
    if (this.action === 'add') {
      this.router.navigate(['/page/contract/' + this.contract.id + '/' + this.contract.customer.id]);
      this.clear();

    }
    // this.loadAll();
  }

  protected onSaveError() {
    this.isSaving = false;
  }


  addComment() {
    this.showForm = true;
    this.contract = new Contract();
  }

  clearForm() {
    this.showForm = false;
    this.activeModal.dismiss('cancel');
  }

  clear() {
    this.showForm = false;
    this.activeModal.dismiss('cancel');
  }


  numberWithCommasNumber() {
    const cost = this.contract.cost;
    const y = this.numberWithCommas(cost);
    this.contract.cost = y;
  }

  numberWithCommas(x) {

    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');

    const pattern = /(-?\d+)(\d{3})/;
    while (pattern.test(x)) {
      x = x.replace(pattern, '$1,$2');
    }
    return x;

  }

  disNumberWithCommas(x) {
    if (x) {
      x = x.toString().replace(',', '');
      x = x.toString().replace(',', '');
      x = x.toString().replace(',', '');
      x = x.toString().replace(',', '');
      x = x.toString().replace(',', '');
      x = x.toString().replace(',', '');

      return x;
    }
  }


}
